import React from "react"
import { useTranslation } from "react-i18next"

import { Layout } from "~/components/Layout/Layout"

import { Content } from "./components/Content/Content"
import { Hero } from "./components/Hero/Hero"

const Obligation: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layout
      description={t("obligation.Hero.Lead")}
      headerTheme="onDark"
      title={t("page.obligation")}
    >
      <Hero />
      <Content />
    </Layout>
  )
}

export default Obligation
